<script lang="ts">
import { onMounted, ref } from "vue";
import "@/style/views/common/FooterView.scss";

export default {
  name: "FooterView",
  setup() {
    const root = ref();
    onMounted(() => {
      root.value = window.location.pathname;
    });
    return {
      root,
    };
  },
};
</script>

<template>
  <div class="footer">
    <hr>
    <div class="columns">
      <div class="column">
        <a href="https://www.inrae.fr/">
          <img
            class="logo_vert"
            src="@/assets/Logo-INRAE.svg"
            alt="Accès page de l’institut national de recherche pour l’agriculture, l’alimentation et l’environnement"
          >
        </a>
      </div>
      <div class="column">
        <img
          class="logo_anaee"
          src="@/assets/logo-AnaEE-france.png"
          alt="Logo de l'Infrastructure de recherche nationale AnaEE France (Analyses et Expérimentations pour les Ecosystèmes)"
        >
      </div>
      <div class="column">
        <img
          class="logo_rep"
          src="@/assets/Rep-FR-logo.svg"
          alt="Logo de la République Française"
        >
      </div>
      <div class="column">
        <img
          class="logo_openADOM"
          src="@/assets/Logo_OpenADOM.svg"
          alt="Accès page de l’institut national de recherche pour l’agriculture, l’alimentation et l’environnement"
        >
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <p :aria-label="$t('footer.info-version-front')">
          {{ $t("footer.info-version-front") }}
        </p>
      </div>
    </div>
  </div>
</template>
